import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import {DetectMethodChanges, isVoid} from '../utils';

@Component({
   selector: 'ets-generic-input-dialog',
   template: `
<dx-popup   class="popup"
      [width]="400"
      [height]="210"
      [showTitle]="true"
      [title]="this.title"
      [closeOnOutsideClick]="false"
      [resizeEnabled]="true"
      [dragEnabled]="true"
      [visible]="this.visible"
      [showCloseButton]="false"
            (onInitialized)="this.onInitialized($event)"
>
   <div *dxTemplate="let data of 'content'" class="wrapper">
      <div class="message">
        <div class="label">
          {{this.label}}
        </div>
        <div class="input">
          <dx-text-box [(value)]="this.inputText"></dx-text-box>
        </div>
      </div>
      <div class="buttons">
        <div class="btn">
          <dx-button
            [text]="this.confirmText"
            (onClick)="this.onConfirm()"
            width="100%"
            type="success"
          ></dx-button>
        </div>
        <div class="btn">
          <dx-button
            [text]="this.rejectText"
            (onClick)="this.onReject()"
            width="100%"
            type="danger"
          ></dx-button>
        </div>
      </div>
   </div>
</dx-popup>
   `,
   styles: [`
       .wrapper {
           display: flex;
           flex-direction: column;
           padding: 15px;
       }

       .message {
           flex: 1;

           display: flex;
           flex-direction: column;
           row-gap: 10px;
           
           font-size: 1.2em;
           text-align: center;
       }

       .buttons {
           display: flex;
           justify-content: space-around;
           align-items: center;
           column-gap: 20px;
           
           .btn {
               flex: 1;
           }
       }
   `],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericInputDialogComponent implements OnInit, AfterViewInit {

   constructor(
      private _changeDetector: ChangeDetectorRef
   ) { }

   private _onReject: (reason?: any) => void;

   private _onResolve: (value?: (PromiseLike<string> | string)) => void;

   @Input()
   visible: boolean;

   @Input()
   title: string;

   @Input()
   label: string;

   @Input()
   placeholder: string;

   inputText: string;

   @Input()
   confirmText = 'Apply';

   @Input()
   rejectText = 'Cancel';

   ngOnInit(): void {

   }

   ngAfterViewInit(): void {
      //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
      //Add 'implements AfterViewInit' to the class.
      this._changeDetector.detach();
   }

   @DetectMethodChanges()
   show(text?: string): Promise<string> {

      if (!isVoid(text)) {
         this.inputText = text;
      }

      this.visible = true;

      return new Promise<string>( (res, rej) => {
         this._onReject = rej;
         this._onResolve = res;
      });

   }

   @DetectMethodChanges()
   onConfirm() {
      this._onResolve(this.inputText);
      this.visible = false;
   }

   @DetectMethodChanges()
   onReject() {
      this._onReject();
      this.visible = false;
   }

   onInitialized($event: any) {
      $event?.component?.registerKeyHandler('escape', (args) => args?.stopPropagation());
   }
}
